import { render, staticRenderFns } from "./AppImagePreview.vue?vue&type=template&id=2e0ffc5f&scoped=true&"
import script from "./AppImagePreview.vue?vue&type=script&lang=js&"
export * from "./AppImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./AppImagePreview.vue?vue&type=style&index=0&id=2e0ffc5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ffc5f",
  null
  
)

export default component.exports